import { ReactElement } from 'react';
import ReactRouterPrompt from 'react-router-prompt';

import ConfirmModal from '~/ui/components/common/ConfirmModal';

interface IProps {
  when: boolean;
  description: string;
  beforeConfirm?: () => void;
}

const NavigationConfirmModal = ({
  when = true,
  description = 'Are you sure you want to leave this page?',
  beforeConfirm,
}: IProps): ReactElement => {
  function delayPromise(ms = 0) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }
  return (
    <ReactRouterPrompt
      when={when}
      beforeConfirm={
        beforeConfirm
          ? async () => {
              await delayPromise();
              beforeConfirm?.();
            }
          : undefined
      }
    >
      {({ onConfirm, onCancel }) => (
        <ConfirmModal description={description} onClose={onCancel} onConfirm={onConfirm} />
      )}
    </ReactRouterPrompt>
  );
};

export default NavigationConfirmModal;
